import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';

import { getDateString } from '../../../utils/dateUtil';
import DatePicker from '../../DatePicker';

import './datepickerstyle.scss';

const FilterDatePicker = ({
  isActive,
  filter,
  searchBlueprint
}) => {
  const dispatch = useDispatch();

  const getDateObject = () => {
    if (filter?.value) {
      // Passed with value 'now' from preset button click.
      const date = filter.value !== 'now' ? dayjs(filter.value) : dayjs();
      return new Date(date);
    }

    return null;
  };

  const [date, setDate] = useState(getDateObject());

  return (
    <DatePicker
      existingDate={date}
      isDisabled={!filter.operator || !isActive}
      placeholderText="Click to pick a date"
      textStyle="bodyMd"
      width="304px"
      onDateSelect={val => {
        const dateString = getDateString(val);
        setDate(val);
        dispatch(searchBlueprint.updateStagedFilter({ value: dateString }));
      }}
    />
  );
};

FilterDatePicker.propTypes = {
  isActive: PropTypes.bool,
  // eslint-disable-next-line react/forbid-prop-types
  filter: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  searchBlueprint: PropTypes.object
};

export default FilterDatePicker;
